<template>
  <label class="cs-switch" :class="{ 'cs-switch--on': value, 'cs-switch--disabled': disabled }">
    <span class="cs-switch__track" @click="toggle">
      <span class="cs-switch__thumb"></span>
    </span>
    <span v-if="label || $slots.default" class="cs-switch__label"><slot>{{ label }}</slot></span>
  </label>
</template>

<script>
/**
 * Reusable toggle switch — our own styling. v-model (boolean).
 */
export default {
  name: 'CustomSwitch',
  props: {
    value: { type: Boolean, default: false },
    label: { type: String, default: '' },
    disabled: { type: Boolean, default: false }
  },
  methods: {
    toggle() {
      if (this.disabled) return;
      this.$emit('input', !this.value);
      this.$emit('change', !this.value);
    }
  }
};
</script>

<style scoped>
.cs-switch { display: inline-flex; align-items: center; gap: 0.55rem; cursor: pointer; user-select: none; }
.cs-switch--disabled { opacity: 0.55; cursor: not-allowed; }
.cs-switch__track {
  position: relative;
  width: 40px;
  height: 22px;
  border-radius: 999px;
  background: #cfd4da;
  transition: background .18s ease;
  flex-shrink: 0;
}
.cs-switch--on .cs-switch__track { background: #343841; }
.cs-switch__thumb {
  position: absolute;
  top: 2px; left: 2px;
  width: 18px; height: 18px;
  border-radius: 50%;
  background: #fff;
  box-shadow: 0 1px 3px rgba(0,0,0,0.25);
  transition: transform .18s ease;
}
.cs-switch--on .cs-switch__thumb { transform: translateX(18px); }
.cs-switch__label { font-size: 0.88rem; font-weight: 600; color: #555; }
</style>
